import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=57d63fb6&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=57d63fb6&prod&scoped=true&lang=css"
import style1 from "./breadcrumb.vue?vue&type=style&index=1&id=57d63fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d63fb6",
  null
  
)

export default component.exports